enum HealthState {
  PreferNotToSay = 0,
  Perfect = 1,
  Minor = 2,
  Moderate = 3,
  Major = 4
}

export default HealthState;
